const state = {
    htInFields: [
        {
            key: "quench_furn_in_time",
            label: "焠火入料時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
        },
        {
            key: "tempering_furn_in_time",
            label: "回火入料時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
        },
    ],
    htWorkDataItem: [],
}
const getters = {
    get_htWorkDataItem: state => {
        return state.htWorkDataItem
    },
    get_htInFields: state => {
        return state.htInFields
    },
}
const actions = {
    set_htWorkDataItem(context, array) {
        context.commit('SET_HTWORKDATAITEM', array);
    },
    set_htInFields(context, array) {
        context.commit('SET_HTINFIELDS', array);
    },
}
const mutations = {
    SET_HTWORKDATAITEM(state, array) {
        state.htWorkDataItem = array;
    },
    SET_HTINFIELDS(state, array) {
        state.htInFields = array;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/htWorkData.js